import type {
  SupplyCorrection,
  SupplyCorrectionParams,
  SupplyCorrectionsResponse,
  SupplyTimelineParams,
  SupplyTimelineResponse,
} from '@gozoki/api-types'

import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchSupplyTimeline = async (
  selection: SupplyTimelineParams,
): Promise<SupplyTimelineResponse> => {
  const params: Record<string, string> = { days: String(selection.days) }
  if (selection.corrections === false) {
    params.corrections = 'false'
  }
  if (selection.targetId !== undefined) {
    params.targetId = String(selection.targetId)
    params.scope = selection.scope ?? 'category'
  }

  const response = await gozokiApiWithAuth.get<SupplyTimelineResponse>(
    `/stores/${selection.storeId}/supply/timeline`,
    { params },
  )
  return response.data
}

export const fetchSupplyCorrections = async (storeId: number): Promise<SupplyCorrection[]> => {
  const response = await gozokiApiWithAuth.get<SupplyCorrectionsResponse>(
    `/stores/${storeId}/supply/corrections`,
  )
  return response.data.corrections
}

export const putSupplyCorrection = async ({
  storeId,
  ...body
}: SupplyCorrectionParams): Promise<SupplyCorrection> => {
  const response = await gozokiApiWithAuth.put<SupplyCorrection>(
    `/stores/${storeId}/supply/corrections`,
    body,
  )
  return response.data
}
